import { render, staticRenderFns } from "./SystemTicketsLogging.vue?vue&type=template&id=89d3cce6&"
import script from "./SystemTicketsLogging.vue?vue&type=script&lang=js&"
export * from "./SystemTicketsLogging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports